import React, { useContext } from 'react';
import { Icon } from 'components/Icon';
import { faArrowLeft, faArrowRight, faCompress, faExpand, faMinus, faPlus, faRotateLeft, faRotateRight } from '@fortawesome/free-solid-svg-icons';
import { CarouselContext } from './CarouselContext';

const Control = ({ onClick, icon, className }) => (
    <div onClick={onClick} className={`img-slider-controls-item ${className}`}>
        <Icon icon={icon} />
    </div>
);

const Controls = () => {
    const {
        galleryImages,
        imgTransform,
        currentIndex,
        zoomOut,
        zoomIn,
        back,
        next,
        setIsFullScreen,
        isFullScreen,
        enableRotate = false,
        handleRotate,
    } = useContext(CarouselContext);

    const disableRotate = galleryImages[0].original === '/static/images/storage-treasures-icon-man.jpg';

    return (
        <div className="img-slider-controls-container">
            <Control className={currentIndex === 0 ? 'disabled' : ''} icon={faArrowLeft} onClick={back} />
            <Control className={currentIndex === galleryImages.length - 1 ? 'disabled' : ''} icon={faArrowRight} onClick={next} />
            <Control className={imgTransform[currentIndex].zoom === 1 ? 'disabled' : ''} icon={faMinus} onClick={zoomOut} />
            <Control className={imgTransform[currentIndex].zoom === 3 ? 'disabled' : ''} icon={faPlus} onClick={zoomIn} />
            {enableRotate && (
                <>
                    <Control 
                        className={disableRotate ? 'disabled' : ''} 
                        icon={faRotateLeft} 
                        onClick={!disableRotate ? () => handleRotate('left') : null} 
                    />
                    <Control 
                        className={disableRotate ? 'disabled' : ''} 
                        icon={faRotateRight} 
                        onClick={!disableRotate ? () => handleRotate('right') : null} 
                    />
                </>
            )}
            <Control icon={isFullScreen ? faCompress : faExpand} onClick={() => setIsFullScreen(!isFullScreen)}/>
        </div>
    );
};

export default Controls;